import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=1acf10bc&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=1acf10bc&prod&lang=scss&scoped=true"
import style1 from "./ProductManagement.vue?vue&type=style&index=1&id=1acf10bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf10bc",
  null
  
)

export default component.exports